import axios from '../base/axios';
import API_KEY from './key';

const GET_MYSTERY = 'flixfrenzy/redux/GET_MYSTERY';

// eslint-disable-next-line default-param-last
const mysteryReducer = (state = [], action) => {
  switch (action.type) {
    case GET_MYSTERY:
      return action.payload;
    default:
      return state;
  }
};

export const getMystery = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=9648`).then((res) => {
    dispatch({
      type: GET_MYSTERY,
      payload: res.data,
    });
  });
};

export default mysteryReducer;
